import { render, staticRenderFns } from "./CallWidget.vue?vue&type=template&id=43991197&"
import script from "./CallWidget.vue?vue&type=script&lang=js&"
export * from "./CallWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports